const CONFIG = {
    BACKEND_URL: "http://127.0.0.1:8000",
    //BACKEND_URL: "https://botspotting-backend.onrender.com",
    ANOTHER_CONSTANT: "some_value",
};

export default CONFIG;
